import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Lightbulb } from 'lucide-react';

export function Register() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#212323] flex flex-col items-center justify-center px-4">
      {/* Logo */}
      <div className="flex items-center mb-8">
        <Lightbulb className="h-16 w-16 text-[#F8B500]" />
        <h1 className="text-4xl font-bold text-white ml-4">
          PITCH<span className="text-[#F8B500]">lift</span>
        </h1>
      </div>

      {/* Sign Up Text */}
      <h2 className="text-3xl font-bold text-[#F8B500] mb-16">
        SIGN UP
      </h2>

      {/* Role Selection Buttons */}
      <div className="w-full max-w-xs space-y-4">
        <Link to="/register/studio" className="block">
          <Button
            variant="outline"
            className="w-full text-lg py-6 border-2"
            size="lg"
          >
            STUDIO
          </Button>
        </Link>

        <Link to="/register/filmmaker" className="block">
          <Button
            variant="outline"
            className="w-full text-lg py-6 border-2"
            size="lg"
          >
            FILMMAKER
          </Button>
        </Link>
      </div>

      {/* Sign In Link */}
      <p className="mt-8 text-gray-400">
        Already have an account?{' '}
        <Link to="/login" className="text-[#F8B500] hover:text-[#F8B500]/80">
          Sign in
        </Link>
      </p>
    </div>
  );
}